<template>
    <section class="py-10 lg:py-20 bg-lifeboost-red-lighter">
        <div class="grid px-4 mx-auto max-w-screen-xl lg:gap-y-8">
            <div class="grid grid-cols-1 gap-y-8 items-center md:grid-cols-2 lg:gap-x-0 md:gap-x-12 md:gap-y-0">
                <div>
                    <h3 class="mb-4 text-center uppercase font-ww-light h2 md:text-left" v-html="titleText"></h3>
                    <div class="textp text-deep" v-html="storyText"></div>
                </div>
                <div>
                    <nuxt-img :width="image1Width" :height="image1Height" format="webp" :src="image1Src"
                        alt="section image" class="object-cover mx-auto lg:pl-10" loading="lazy"
                        sizes="xs:330px sm:440px md:400px lg:388px xl:551px" />
                    <nuxt-img :width="image2Width" :height="image2Height" format="webp" :src="image2Src"
                        alt="section image" class="object-cover mx-auto lg:pl-10" loading="lazy"
                        sizes="xs:330px sm:440px md:400px lg:388px xl:551px" />
                </div>
            </div>
            <div class="grid gap-x-6 gap-y-6 items-center lg:grid-cols-12 lg:gap-y-0">
                <div class="flex flex-col col-span-12 gap-y-8 lg:grid lg:flex-row lg:col-span-6 lg:pr-10 sm-max:order-2">
                    <nuxt-img :width="image3Width" :height="image3Height" format="webp" :src="image3Src"
                        alt="section image" class="object-cover mx-auto" loading="lazy"
                        sizes="xs:330px sm:440px md:400px lg:388px xl:551px" />
                    <nuxt-img :width="image4Width" :height="image4Height" format="webp" :src="image4Src"
                        alt="section image" class="object-cover mx-auto" loading="lazy"
                        sizes="xs:330px sm:440px md:400px lg:388px xl:551px" />
                </div>
                <div class="col-span-12 mt-4 lg:col-span-6 md:mt-0">
                    <div>
                        <div class="textp text-deep" v-html="secondStoryText"></div>
                    </div>
                </div>
                <div class="col-span-12 lg:mt-8 textp text-deep" v-html="footerText"></div>
            </div>
        </div>
    </section>
</template>

<script setup>

const props = defineProps({
    titleText: {
        type: String,
        default: "Frosted Sugar Cookie"
    },
    storyText: {
        type: String,
        default: `<strong>“Did I ever tell you about the first date your mother and I ever went on?”</strong><br><br>
                  “Yes, dad,” the twins replied with a smirky grin.<br><br>
                  “Ah, it feels like it was just yesterday.”<br><br>
                  “I’m pretty sure you just told us this story last week, dad.”<br><br>
                  “So, there she was, <strong>her nose stuck in a book, sitting underneath the big oak tree in the quad.</strong><br><br>
                  I couldn’t believe anyone could be so captivated. <strong>This beautiful woman was so enthralled</strong> by what she was reading that life seemed not to exist outside of the paper world held in her hand.<br><br>
                  I walked by that tree every afternoon coming home from class, and every single day...<strong>there she sat.</strong><br><br>
                  <strong>Finally, I decided I had to meet her.</strong>`
    },
    secondStoryText: {
        type: String,
        default: `Not being much of a reader, I haphazardly checked out a book from the library and sat down
                  with said book on the other side of the tree not even a full 2 feet from her.<br><br>
                  Then, after recklessly flipping through a few pages, I spoke. I asked what she was reading,
                  and she laughed at me. Your mother’s first response to your old man was that I was a joke.<br><br>
                  She was right. She saw right through my attempt and didn’t reply with the answer to my
                  direct question, but to the question I was building up to ask.”<br><br>
                  “Sure. I could go for a coffee break right now anyways.”<br><br>
                  “I was stunned. I mean, to be honest, I actually didn’t even drink coffee during my college
                  years. It was your mother that got me fixated on the bean.”<br><br>
                  “Really, dad? The bean?”<br><br>
                  “Anyways, she stood straight up and of course, I stumblingly followed.<br><br>
                  We went to the local college coffeehouse, the only one on campus. She ordered a small medium
                  roast, black. And, I ordered the same, along with a frosted sugar cookie.<br><br>
                  My parents always brewed some generic store bought coffee. The smell wasn’t great anyways,
                  but my mom generally burned the coffee too, so my history with the bean wasn’t all that
                  grand.<br><br>
                  But this coffee...this coffee was purely perfect, just like your mother.<br><br>
                  We sat and talked for hours.<br><br>
                  And, later I had to finally admit to her that I was just as enamored with that coffee and
                  frosted sugar cookie combo as I was with her. ...well, not on the same level, but it was so
                  amazing that we go to the same coffeehouse every year on the anniversary of that date to
                  enjoy the same treat.<br><br>
                  The aroma of the coffee was like nothing I’d experienced, bold and robust. The flavor was
                  rich, with such incredible depth.`
    },
    footerText: {
        type: String,
        default: `Ah, and paired with that sugar cookie! The frosting was sweet and velvety, the cookie was delicately
                  decadent, so rich, sweet, and buttery.”<br><br>
                  “Well, well, well, I see you’re telling our children about how much you love frosted sugar cookies
                  and coffee...am I even in this story anymore?”<br><br>
                  “Oh, hi dear. Of course you’re in the story. You’re the reason for the story!”<br><br>
                  The twins and their mother laughed in unison...their father still clearly thinking of the delectable
                  confectionary combination.`
    },
    image1Src: {
        type: String,
        default: '/assets/images/cookie-1.png'
    },
    image1Width: {
        type: Number,
        default: 551
    },
    image1Height: {
        type: Number,
        default: 441
    },
    image2Src: {
        type: String,
        default: '/assets/images/cookie-2.png'
    },
    image2Width: {
        type: Number,
        default: 555
    },
    image2Height: {
        type: Number,
        default: 413
    },
    image3Src: {
        type: String,
        default: '/assets/images/cookie-3.png'
    },
    image3Width: {
        type: Number,
        default: 558
    },
    image3Height: {
        type: Number,
        default: 424
    },
    image4Src: {
        type: String,
        default: '/assets/images/cookie-4.png'
    },
    image4Width: {
        type: Number,
        default: 529
    },
    image4Height: {
        type: Number,
        default: 394
    }
});

defineBuilderComponent({
    friendlyName: 'Long Text With Images',
    inputs: [
        {
            name: 'titleText',
            type: 'richText',
            defaultValue: 'Frosted Sugar Cookie'
        },
        {
            name: 'storyText',
            type: 'richText',
            defaultValue: `<strong>“Did I ever tell you about the first date your mother and I ever went on?”</strong><br><br>
                          “Yes, dad,” the twins replied with a smirky grin.<br><br>
                          “Ah, it feels like it was just yesterday.”`
        },
        {
            name: 'secondStoryText',
            type: 'richText',
            defaultValue: `Not being much of a reader, I haphazardly checked out a book from the library and sat down
                          with said book on the other side of the tree not even a full 2 feet from her.`
        },
        {
            name: 'footerText',
            type: 'richText',
            defaultValue: `Ah, and paired with that sugar cookie! The frosting was sweet and velvety, the cookie was delicately
                          decadent, so rich, sweet, and buttery.”`
        },
        {
            name: 'image1Src',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
            defaultValue: '/assets/images/cookie-1.png'
        },
        {
            name: 'image2Src',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
            defaultValue: '/assets/images/cookie-2.png'
        },
        {
            name: 'image3Src',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
            defaultValue: '/assets/images/cookie-3.png'
        },
        {
            name: 'image4Src',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
            defaultValue: '/assets/images/cookie-4.png'
        }
    ]
});
</script>
